module.exports = "p {\n  font-size: 16px;\n  margin-right: 18px;\n  font-weight: bold;\n}\n/*.my-music-name {*/\n/*color: #83cfef !important;*/\n/*!*color: #8dc63f !important;*!*/\n/*}*/\n.my-music-artist {\n    color: #f7941e !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/player/song-info/song-info-details/song-info-details.component.css
// module id = ./src/app/player/song-info/song-info-details/song-info-details.component.css
// module chunks = main